module.exports = __webpack_public_path__ + "media/application/images/img/svg/arrow_right-8ef6a08cdc1154920165680a4edde771.svg";